<script lang="ts" setup>
import Button from "@components/global/button.vue";
import { useGlobalStore } from "@stores/global";

const global = useGlobalStore();

const menuItems = [
  { name: "Home", to: { name: "home" } },
  { name: "Products", to: { name: "products" } },
  { name: "Merch", to: { name: "merch" } },
  { name: "About", to: { name: "about" } },
  { name: "Blog", to: { name: "articles" } },
  { name: "Contact Us", to: { name: "contact" } },
];

const legalPages = [
  {
    name: "Privacy Policy",
    to: { name: "legalPage", params: { slug: "privacy" } },
  },
  {
    name: "Terms of Service",
    to: { name: "legalPage", params: { slug: "terms" } },
  },
  {
    name: "Shipping Policy",
    to: { name: "legalPage", params: { slug: "shipping" } },
  },
  {
    name: "Returns Policy",
    to: { name: "legalPage", params: { slug: "returns" } },
  },
];

const date = new Date().getFullYear();
</script>

<template>
  <footer class="relative w-full flex flex-col justify-end">
    <div class="h-[45vw] sm:h-[30vw] 2xl:h-[25vw]">
      <img
        class="absolute top-20 w-full"
        src="https://hennep.s3.amazonaws.com/above/images/footer/bg.svg"
        alt="Hennep"
      />
      <img
        class="w-[4%] absolute left-[23%] top-[5%] sm:block hidden"
        src="https://hennep.s3.amazonaws.com/above/images/footer/ufo.svg"
        alt="Hennep"
      />
      <img
        class="w-[8%] absolute left-[50%] top-0 sm:block hidden"
        src="https://hennep.s3.amazonaws.com/above/images/footer/ufo2.svg"
        alt="Hennep"
      />
      <img
        class="absolute top-0 left-[20%]"
        src="https://hennep.s3.amazonaws.com/above/images/footer/star2.svg"
        alt="Hennep"
      />
      <img
        class="absolute top-[3%] left-[40%]"
        src="https://hennep.s3.amazonaws.com/above/images/footer/star2.svg"
        alt="Hennep"
      />
      <img
        class="absolute top-[12%] left-[60%]"
        src="https://hennep.s3.amazonaws.com/above/images/footer/star2.svg"
        alt="Hennep"
      />
      <img
        class="absolute top-[7%] left-[80%]"
        src="https://hennep.s3.amazonaws.com/above/images/footer/star2.svg"
        alt="Hennep"
      />
      <img
        class="absolute top-[5%] left-[5%]"
        src="https://hennep.s3.amazonaws.com/above/images/footer/star.svg"
        alt="Hennep"
      />
      <img
        class="absolute top-[15%] left-[35%]"
        src="https://hennep.s3.amazonaws.com/above/images/footer/star.svg"
        alt="Hennep"
      />
      <img
        class="absolute top-[7%] left-[90%]"
        src="https://hennep.s3.amazonaws.com/above/images/footer/star.svg"
        alt="Hennep"
      />
      <img
        class="absolute top-0 left-[75%]"
        src="https://hennep.s3.amazonaws.com/above/images/footer/star.svg"
        alt="Hennep"
      />
    </div>
    <div
      class="w-full uppercase text-purple-300 bg-bg-light md:p-16 md:pb-12 p-4 flex flex-col gap-8 z-images"
    >
      <div class="flex flex-wrap justify-between gap-8">
        <div class="flex flex-col gap-8">
          <h5>Abducted by good vibes.</h5>
          <div class="flex flex-row gap-4 flex-wrap max-w-[240px]">
            <Button
              class="btn-outline small"
              v-for="social in global.socials"
              :key="social.avatar_url"
              :href="social.link"
              :title="`${social.platform?.name} - ${social.username}`"
            >
              <i
                :class="social.platform?.icon"
                class="flex items-center justify-center w-4 h-4"
              />
            </Button>
          </div>
        </div>
        <div class="flex flex-col gap-8">
          <h5>Sitemap</h5>
          <nav class="flex flex-col gap-2">
            <Button v-for="item in menuItems" :key="item.name" :to="item.to">
              {{ item.name }}
            </Button>
          </nav>
        </div>
        <div class="flex flex-col gap-8">
          <h5>legal</h5>
          <nav class="flex flex-col gap-2">
            <Button v-for="item in legalPages" :key="item.name" :to="item.to">
              {{ item.name }}
            </Button>
          </nav>
        </div>
        <div>
          <span class="font-body text-body-sm">
            © Above {{ date }}, All Rights Reserved.
          </span>
        </div>
      </div>
      <img
        src="https://hennep.s3.amazonaws.com/above/images/logo-footer.svg"
        alt=""
      />
    </div>
  </footer>
</template>
